import moment from "moment";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { AppIcons } from "../constants/app-icons";
import { getMyGemService } from "@/services";
import { targetCell } from "../helpers/schedule-column";
export default class SchedularService extends ApiService {
  template = "defaultTemplate";
  namespace = "schedular";
  listingRelations = "peopleCount,target";
  relations =
    "?expand=peopleSimple,files,files.file,files.file.commentsCount,target";
  icon = "Schedular";
  favicon = "Schedular";
  DOMAIN = 209;
  action = "action";

  search = true;
  singular = this.terminology.schedule.singular;
  plural = this.terminology.schedule.plural;
  vowel = this.terminology.schedule.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 1200;
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit " + this.name,
      icon: AppIcons.EDIT,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: this.t("Item"),
      icon: AppIcons.PAPER_CLIP,
      field: "peopleCount",
    },
    {
      header: this.t("target"),
      icon: AppIcons.PAPER_CLIP,
      field: "target",
      template: (data) => targetCell(data),
      click: (data) => {
        if (!data.target || !data.object_id) return null;
        return [
          {
            type: "open-gem",
            gem: {
              item: {
                key: "edit",
                label: this.t("edit"),
                isVisible: true,
                service: getMyGemService(Number(data.domain)),
                item: { id: data.object_id },
              },
            },
          },
        ];
      },
    },
    {
      header: this.t("Next Scheduled"),
      icon: AppIcons.ALARM,
      field: "schedule_time",
      template: (data) => {
        return data.schedule_time > 0
          ? moment.unix(data.schedule_time).format("MM/DD/YYYY HH:ii")
          : "Send Now";
      },
    },
    {
      header: this.t("status"),
      icon: AppIcons.ANNOUNCEMENT,
      field: "is_sent",
      template: (data) => {
        return !data.is_sent
          ? "Pending (Queued)"
          : data.is_sent == 1
            ? "Sent"
            : "Declined";
      },
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a new message",
      icon: PrimeIcons.PLUS,
    },
  ];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit this Message",
        icon: AppIcons.EDIT,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }
  filterItems = [];
  constructor() {
    super("schedulars");
  }
}
